import React from 'react'
import bggif from './bg-unscreen.gif'

const Animated404page = () => {
  return (
    <div>
    <section className="page_404">
      <div className="container mx-auto">
        <div className="flex flex-wrap">
          <div className="w-full">
            <div className="w-10/12 mx-auto text-center">
              <div className="four_zero_four_bg flex flex-col items-center justify-center">
                {/* <h1 className="text-center text-black text-4xl">404</h1> */}
                <img src={bggif} alt='' className=''/>
              </div>

              <div className="contant_box_404">
                <h3 className="h2">Looks like you're lost</h3>
                <p className='mb-4'>The page you are looking for is not available!</p>
                <a href="/" className="link_404 bg-orange-500 text-white px-2 py-1 rounded mt-4">Go to Home</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
</div>
  )
}

export default Animated404page